export const setApprovedAreas = approvedAreas => ({
  type: 'SET_APPROVED_AREAS',
  payload: approvedAreas,
});

export const addApprovedArea = approvedArea => ({
  type: 'ADD_APPROVED_AREA',
  payload: approvedArea,
});

export const removeApprovedArea = approvedArea => ({
  type: 'REMOVE_APPROVED_AREA',
  payload: approvedArea,
});

export const editApprovedArea = approvedArea => ({
  type: 'EDIT_APPROVED_AREA',
  payload: approvedArea,
});
